export default "__VITE_ASSET__3AhwdS1x__"